/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { AccordionComponentDisplay } from "cms/components/components/accordion/display";
import { AccordionComponentEditor } from "cms/components/components/accordion/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const AccordionComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <AccordionComponentDisplay />,
        editComponent: <AccordionComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

AccordionComponent.displayName = "AccordionComponent";
export { AccordionComponent };
